import {BASE_URL} from 'appConstants';

import {post, get} from 'sdk';

export const fetchModelInstances = ({modelType, objectId}) => {
  const url = `${BASE_URL}/v1/search/`;

  let modelTypeData = {};
  if (modelType) {
    modelTypeData = {modelType};
  }

  return post(url, {pk: objectId, ...modelTypeData});
};

export const fetchModelTypes = () => {
  const url = `${BASE_URL}/v1/search/options/`;
  return get(url);
};
